import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";
import moment from "moment";
import { toast } from "react-toastify";
import Notification from "../../../components/Notification";

const SalesBroadCastMessageForm = (props) => {
  return (
    <>
      <div className="content-wrapper">
        <div>&nbsp;</div>
        <section className="content">
          <div className="container-fluid">
            {/* SELECT2 EXAMPLE */}
            <div className="card card-default">
              <div className="card-header">
                <h3 className="card-title">Add Message Detail</h3>
                <div className="card-tools">
                  <button
                    type="button"
                    className="btn btn-tool"
                    data-card-widget="remove"
                    onClick={() => props.addForm(false)}
                  >
                    <i className="fas fa-times" />
                  </button>
                </div>
              </div>
              <Notification  useCase="Sales"/>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default SalesBroadCastMessageForm;
